import React from 'react';
// import axios from './../../../../constants/axios';

class ProductSubHome extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         product: {}
      };
   }

   // componentDidMount() {
   //    const productId = this.props.params.productId;
   //    axios.get(`items/products/main/${productId}`)
   //       .then((res) => {
   //          this.setState({
   //             product: res.data
   //          });
   //       });
   // }

   render() {
      // const {product} = this.state;
      return (
         <div>
            <h4>General Information</h4>
            <div>
               {/*<p>Name: {product.name}</p>*/}
               {/*<p>Description: {product.description}</p>*/}
               {/*<p>Price: {product.price}</p>*/}
               {/*<p>Discount: {product.discount}</p>*/}
               {/*<p>Net Weight: {product.net_weight}</p>*/}

               <hr/>
               <h4>Main Image</h4>


               <hr/>
               <h4>Images</h4>

               <hr/>
               <h4>Locations</h4>

               <hr/>
               <h4>Features</h4>

            </div>
         </div>
      );
   }
}

ProductSubHome.propTypes = {
   params: React.PropTypes.object
};

export default ProductSubHome;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductSub/ProductSubHome.js
 **/